import usePaginatedFetch from "../core/usePaginatedFetch";

/**
 * Hook to get top traders with pagination
 */
export const useTopTraders = (timeRange = "1w", limit = 10) =>
  usePaginatedFetch("/top-traders", { timeRange, limit });

/**
 * Hook to get biggest losers with pagination
 */
export const useBiggestLosers = (timeRange = "1w", limit = 10) =>
  usePaginatedFetch("/biggest-losers", { timeRange, limit });

/**
 * Hook to get top volume gainers with pagination
 */
export const useTopVolumeGainers = (timeRange = "1d", limit = 10) =>
  usePaginatedFetch("/top-volume-gainers", { timeRange, limit });

/**
 * Hook to get top tokens by holders with pagination
 */
export const useTopTokensByHolders = (timeRange = "1w", limit = 10) =>
  usePaginatedFetch("/top-tokens-by-holders", { timeRange, limit });

/**
 * Hook to get large sell trades with pagination
 */
export const useLargeSellTrades = (timeRange = "1d", limit = 10) =>
  usePaginatedFetch("/large-sell-trades", { timeRange, limit });

/**
 * Hook to get large buy trades with pagination
 */
export const useLargeBuyTrades = (timeRange = "1d", limit = 10) =>
  usePaginatedFetch("/large-buy-trades", { timeRange, limit });
